import { API } from "../../../backend";
import { objectToQueryString } from "../../../lib/utils";

export const getAppointmentSlots=(userId,token,appointmentslotsId)=>{
  return fetch(`${API}/appointmentslots/${userId}/${appointmentslotsId}`,{
    method:'get',
    headers:{
      Accept:"application/json",
      Authorization:`Bearer ${token}`
    }
  }).then(res=>{
    return res.json();
  }).catch(err => { console.error(err); return { error: true, message: err?.message }; })
}

export const getAppointmentSlotsCount=(userId,token,query)=>{
  let str=objectToQueryString(query);
  return fetch(`${API}/fetch-appointmentslots/count/${userId}?${str}`,{
    method:'get',
    headers:{
      Accept:'application/json',
      Authorization:`Bearer ${token}`
    }
  }).then(res=>res.json()).catch(err => { console.error(err); return { error: true, message: err?.message }; })
}


export const getAllAppointmentSlots=(userId,token,query)=>{
  let str=objectToQueryString(query);
  return fetch(`${API}/fetch-all/appointmentslots/${userId}?${str}`,{
    method:'get',
    headers:{
      Accept:'application/json',
      Authorization:`Bearer ${token}`
    }
  }).then(res=>res.json()).catch(err => { console.error(err); return { error: true, message: err?.message }; })
}

export const saveAppointmentSlots=(userId,token,body)=>{
  return fetch(`${API}/save/appointmentslots/${userId}`,{
    method:"post",
    headers:{
      Accept:"application/json",
      'Content-Type':"application/json",
      Authorization:`Bearer ${token}`
    },
    body:JSON.stringify(body)
  }).then(res=>res.json()).catch(err => { console.error(err); return { error: true, message: err?.message }; })
}


export const removeAppointmentSlots=(userId,token,appointmentslotsId)=>{
  return fetch(`${API}/delete/appointmentslots/${userId}/${appointmentslotsId}`,{
    method:'DELETE',
    headers:{
      Accept:"application/json",
      Authorization:`Bearer ${token}`
    },
  }).then(res=>res.json()).catch(err => { console.error(err); return { error: true, message: err?.message }; })
}


//appointment

export const getAppointment=(userId,token,appointmentId)=>{
  return fetch(`${API}/appointment/${userId}/${appointmentId}`,{
    method:'get',
    headers:{
      Accept:"application/json",
      Authorization:`Bearer ${token}`
    }
  }).then(res=>{
    return res.json();
  }).catch(err => { console.error(err); return { error: true, message: err?.message }; })
}

export const getAppointmentCount=(userId,token,query)=>{
  let str=objectToQueryString(query);
  return fetch(`${API}/appointments/count/${userId}?${str}`,{
    method:'get',
    headers:{
      Accept:'application/json',
      Authorization:`Bearer ${token}`
    }
  }).then(res=>res.json()).catch(err => { console.error(err); return { error: true, message: err?.message }; })
}


export const getAllAppointment=(userId,token,query)=>{
  let str=objectToQueryString(query);
  return fetch(`${API}/appointments/${userId}?${str}`,{
    method:'get',
    headers:{
      Accept:'application/json',
      Authorization:`Bearer ${token}`
    }
  }).then(res=>res.json()).catch(err => { console.error(err); return { error: true, message: err?.message }; })
}

export const saveAppointMent=(userId,token,body)=>{
  return fetch(`${API}/create/appointment/${userId}`,{
    method:"post",
    headers:{
      Accept:"application/json",
      'Content-Type':"application/json",
      Authorization:`Bearer ${token}`
    },
    body:JSON.stringify(body)
  }).then(res=>res.json()).catch(err => { console.error(err); return { error: true, message: err?.message }; })
}

export const updateAppointment=(userId,token,appointmentId,body)=>{
  return fetch(`${API}/update/appointment/${userId}/${appointmentId}`,{
    method:"put",
    headers:{
      Accept:"application/json",
      'Content-Type':"application/json",
      Authorization:`Bearer ${token}`
    },
    body:JSON.stringify(body)
  }).then(res=>res.json()).catch(err => { console.error(err); return { error: true, message: err?.message }; })
}


export const deleteAppointments=(userId,token,body)=>{
  return fetch(`${API}/delete/appointments/${userId}`,{
    method:'PUT',
    headers:{
      Accept:"application/json",
      'Content-Type':"application/json",
      Authorization:`Bearer ${token}`
    },
    body:JSON.stringify(body)
  }).then(res=>res.json()).catch(err => { console.error(err); return { error: true, message: err?.message }; })
}


export const removeMemberFromAppointment = (userId, token , payload)=>{
   return fetch(`${API}/appointment/remove-member/${userId}`,{
    method:'POST',
    headers:{
      Accept:"application/json",
      'Content-Type':"application/json",
      Authorization:`Bearer ${token}`
    },
    body:JSON.stringify(payload)
  }).then(res=>res.json()).catch(err => { console.error(err); return { error: true, message: err?.message }; })
}

//end of appointment API 